import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { User, Save, X } from 'lucide-react';
import { MessageModal } from '../../components/modals/MessageModal';
export function EditProfilePage() {
  const navigate = useNavigate();
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: 'Amit Sharma',
    email: 'amit.sharma@example.com',
    phone: '+91 98765 43210',
    address: '123 MG Road',
    city: 'Pune',
    state: 'Maharashtra',
    pincode: '411001',
    country: 'India'
  });
  const navItems = [{
    label: 'Dashboard',
    icon: User,
    path: '/dashboard'
  }, {
    label: 'Profile',
    icon: User,
    path: '/profile'
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsMessageModalOpen(true);
    setTimeout(() => {
      navigate('/profile');
    }, 2000);
  };
  const handleCancel = () => {
    navigate('/profile');
  };
  return <DashboardLayout title="Edit Profile" navItems={navItems} userInitials="AS" data-id="element-5307">
      <div className="max-w-3xl mx-auto" data-id="element-5308">
        <h1 className="text-2xl font-bold mb-8" data-id="element-5309">Edit Profile</h1>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-300 p-8" data-id="element-5310">
          <div className="space-y-6" data-id="element-5311">
            {/* Basic Information */}
            <div data-id="element-5312">
              <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-5313">
                Basic Information
              </h2>
              <div className="space-y-4" data-id="element-5314">
                <div data-id="element-5315">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5316">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5317" />
                </div>

                <div data-id="element-5318">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5319">
                    Email Address *
                  </label>
                  <input type="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5320" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-5321">
                    Changing email will require verification
                  </p>
                </div>

                <div data-id="element-5322">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5323">
                    Phone Number *
                  </label>
                  <input type="tel" required value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5324" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-5325">
                    Changing phone will require OTP verification
                  </p>
                </div>
              </div>
            </div>

            {/* Address Information */}
            <div data-id="element-5326">
              <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-5327">
                Address Information
              </h2>
              <div className="space-y-4" data-id="element-5328">
                <div data-id="element-5329">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5330">
                    Street Address
                  </label>
                  <input type="text" value={formData.address} onChange={e => setFormData({
                  ...formData,
                  address: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5331" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5332">
                  <div data-id="element-5333">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5334">
                      City
                    </label>
                    <input type="text" value={formData.city} onChange={e => setFormData({
                    ...formData,
                    city: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5335" />
                  </div>

                  <div data-id="element-5336">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5337">
                      State
                    </label>
                    <input type="text" value={formData.state} onChange={e => setFormData({
                    ...formData,
                    state: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5338" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5339">
                  <div data-id="element-5340">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5341">
                      PIN Code
                    </label>
                    <input type="text" value={formData.pincode} onChange={e => setFormData({
                    ...formData,
                    pincode: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5342" />
                  </div>

                  <div data-id="element-5343">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5344">
                      Country
                    </label>
                    <select value={formData.country} onChange={e => setFormData({
                    ...formData,
                    country: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5345">
                      <option value="India" data-id="element-5346">India</option>
                      <option value="USA" data-id="element-5347">USA</option>
                      <option value="UK" data-id="element-5348">UK</option>
                      <option value="UAE" data-id="element-5349">UAE</option>
                      <option value="Singapore" data-id="element-5350">Singapore</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-3 pt-6 border-t border-gray-200" data-id="element-5351">
              <button type="button" onClick={handleCancel} className="flex items-center gap-2 px-6 py-3 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-5352">
                <X className="w-4 h-4" data-id="element-5353" />
                Cancel
              </button>
              <button type="submit" className="flex items-center gap-2 px-6 py-3 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5354">
                <Save className="w-4 h-4" data-id="element-5355" />
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Profile Updated" message="Your profile has been updated successfully." type="success" data-id="element-5356" />
    </DashboardLayout>;
}